import { render } from "./DepartmentsCol.vue?vue&type=template&id=21b40762&scoped=true"
import script from "./DepartmentsCol.vue?vue&type=script&lang=js"
export * from "./DepartmentsCol.vue?vue&type=script&lang=js"

import "./DepartmentsCol.vue?vue&type=style&index=0&id=21b40762&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b40762"]])

export default __exports__